var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.alumnoForm.participante.cvu,
              expression: "!alumnoForm.participante.cvu",
            },
          ],
        },
        [
          _c(
            "b-col",
            [
              _c("h5", {
                domProps: {
                  textContent: _vm._s(
                    _vm.$t("apeironGwApp.matriculaGpln.form.buscarAlumno")
                  ),
                },
              }),
              _vm._v(" "),
              _vm.solicitud.programa?.clave
                ? _c("buscador-persona", {
                    on: { selected: _vm.seleccionarAlumno },
                  })
                : _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("apeironGwApp.matriculaGpln.mensajeSecciones")
                      )
                    ),
                  ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.alumnoForm.participante.cvu,
              expression: "alumnoForm.participante.cvu",
            },
          ],
        },
        [
          _c(
            "b-col",
            [
              !_vm.periodoEstudiosValido() &&
              !_vm.$v.alumnoForm.participante.finEstudios.$invalid
                ? _c("b-alert", { attrs: { variant: "danger", show: "" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "apeironGwApp.matriculaGpln.form.periodoEstudiosValido",
                            _vm.periodoBecaTexto
                          )
                        ) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.debeRestringirRegistroPorGenero
                ? _c("b-alert", { attrs: { variant: "danger", show: "" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("apeironGwApp.matriculaGpln.form.soloMujeres")
                        ) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.matriculaGpln.form.cvuAlumno"
                              ) + " *",
                            "label-for": "input-cvu",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              name: "input-cvu",
                              state:
                                !_vm.$v.alumnoForm.participante.cvu.$invalid,
                              placeholder: _vm.$t(
                                "apeironGwApp.matriculaGpln.form.cvuAlumno"
                              ),
                              disabled: "",
                            },
                            model: {
                              value: _vm.alumnoForm.participante.cvu,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.alumnoForm.participante,
                                  "cvu",
                                  $$v
                                )
                              },
                              expression: "alumnoForm.participante.cvu",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label:
                              _vm.$t("apeironGwApp.matriculaGpln.form.curp") +
                              " *",
                            "label-for": "input-curp",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              name: "input-curp",
                              state:
                                !_vm.$v.alumnoForm.participante.curp.$invalid,
                              placeholder: _vm.$t(
                                "apeironGwApp.matriculaGpln.form.curp"
                              ),
                              disabled: "",
                            },
                            model: {
                              value: _vm.alumnoForm.participante.curp,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.alumnoForm.participante,
                                  "curp",
                                  $$v
                                )
                              },
                              expression: "alumnoForm.participante.curp",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.matriculaGpln.form.nombreAlumno"
                              ) + " *",
                            "label-for": "input-nombre-alumno",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              name: "input-nombre-alumno",
                              state:
                                !_vm.$v.alumnoForm.participante.nombre.$invalid,
                              placeholder: _vm.$t(
                                "apeironGwApp.matriculaGpln.form.nombreAlumno"
                              ),
                              disabled: "",
                            },
                            model: {
                              value: _vm.alumnoForm.participante.nombre,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.alumnoForm.participante,
                                  "nombre",
                                  $$v
                                )
                              },
                              expression: "alumnoForm.participante.nombre",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.matriculaGpln.form.apellidoPaterno"
                              ) + " *",
                            "label-for": "input-apellido-paterno",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              name: "input-apellido-paterno",
                              state:
                                !_vm.$v.alumnoForm.participante.apellidoPaterno
                                  .$invalid,
                              placeholder: _vm.$t(
                                "apeironGwApp.matriculaGpln.form.apellidoPaterno"
                              ),
                              disabled: "",
                            },
                            model: {
                              value:
                                _vm.alumnoForm.participante.apellidoPaterno,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.alumnoForm.participante,
                                  "apellidoPaterno",
                                  $$v
                                )
                              },
                              expression:
                                "alumnoForm.participante.apellidoPaterno",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label: _vm.$t(
                              "apeironGwApp.matriculaGpln.form.apellidoMaterno"
                            ),
                            "label-for": "input-apellido-materno",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              name: "input-apellido-materno",
                              state:
                                !_vm.$v.alumnoForm.participante.apellidoMaterno
                                  .$invalid,
                              placeholder: _vm.$t(
                                "apeironGwApp.matriculaGpln.form.apellidoMaterno"
                              ),
                              disabled: "",
                            },
                            model: {
                              value:
                                _vm.alumnoForm.participante.apellidoMaterno,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.alumnoForm.participante,
                                  "apellidoMaterno",
                                  $$v
                                )
                              },
                              expression:
                                "alumnoForm.participante.apellidoMaterno",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label: _vm.$t(
                              "apeironGwApp.matriculaGpln.form.tiempoDedicacion"
                            ),
                            "label-for": "input-tiempo-dedicacion",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              name: "input-tiempo-dedicacion",
                              disabled: "",
                            },
                            model: {
                              value: _vm.tiempoDedicacion,
                              callback: function ($$v) {
                                _vm.tiempoDedicacion = $$v
                              },
                              expression: "tiempoDedicacion",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.matriculaGpln.form.tipoBeca"
                              ) + " *",
                            "label-for": "input-tipo-beca",
                          },
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              disabled: "",
                              name: "input-tipo-beca",
                              state:
                                !_vm.$v.alumnoForm.participante.tipoBeca
                                  .$invalid,
                              options: _vm.tiposBeca,
                            },
                            model: {
                              value: _vm.alumnoForm.participante.tipoBeca,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.alumnoForm.participante,
                                  "tipoBeca",
                                  $$v
                                )
                              },
                              expression: "alumnoForm.participante.tipoBeca",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            {
                              attrs: {
                                state:
                                  !_vm.$v.alumnoForm.participante.tipoBeca
                                    .$invalid,
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.matriculaGpln.form.promedioAnterior"
                              ) + " *",
                            "label-for": "input-promedio-anterior",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              name: "input-promedio-anterior",
                              state:
                                !_vm.$v.alumnoForm.participante.promedioAnterior
                                  .$invalid,
                              placeholder: _vm.$t(
                                "apeironGwApp.matriculaGpln.form.promedioAnterior"
                              ),
                              disabled: _vm.readOnly,
                            },
                            model: {
                              value:
                                _vm.alumnoForm.participante.promedioAnterior,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.alumnoForm.participante,
                                  "promedioAnterior",
                                  $$v
                                )
                              },
                              expression:
                                "alumnoForm.participante.promedioAnterior",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            {
                              attrs: {
                                state:
                                  !_vm.$v.alumnoForm.participante
                                    .promedioAnterior.$invalid,
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.matriculaGpln.form.inicioGeneracion"
                              ) + " *",
                            "label-for": "input-inicio-generacion",
                          },
                        },
                        [
                          _c("b-form-datepicker", {
                            attrs: {
                              name: "input-inicio-generacion",
                              placeholder: _vm.$t(
                                "apeironGwApp.matriculaGpln.form.inicioGeneracion"
                              ),
                              disabled: _vm.readOnly,
                              state:
                                !_vm.$v.alumnoForm.participante.inicioGeneracion
                                  .$invalid,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.seleccionarFechaInicioGeneracion()
                              },
                            },
                            model: {
                              value:
                                _vm.alumnoForm.participante.inicioGeneracion,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.alumnoForm.participante,
                                  "inicioGeneracion",
                                  $$v
                                )
                              },
                              expression:
                                "alumnoForm.participante.inicioGeneracion",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            {
                              attrs: {
                                state:
                                  !_vm.$v.alumnoForm.participante
                                    .inicioGeneracion.$invalid,
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t("entity.validation.required")
                                  ),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.matriculaGpln.form.duracionMeses"
                              ) + " *",
                            "label-for": "input-duracion-meses",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              name: "input-duracion-meses",
                              placeholder: _vm.$t(
                                "apeironGwApp.matriculaGpln.form.duracionMeses"
                              ),
                              state:
                                !_vm.$v.alumnoForm.participante.duracionMeses
                                  .$invalid,
                              disabled: "",
                            },
                            model: {
                              value: _vm.alumnoForm.participante.duracionMeses,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.alumnoForm.participante,
                                  "duracionMeses",
                                  $$v
                                )
                              },
                              expression:
                                "alumnoForm.participante.duracionMeses",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.matriculaGpln.form.inicioEstudios"
                              ) + " *",
                            "label-for": "input-inicio-estudios",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              name: "input-inicio-estudios",
                              state:
                                !_vm.$v.alumnoForm.participante.inicioEstudios
                                  .$invalid,
                              placeholder: _vm.$t(
                                "apeironGwApp.matriculaGpln.form.inicioEstudios"
                              ),
                              disabled: "",
                            },
                            model: {
                              value: _vm.alumnoForm.participante.inicioEstudios,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.alumnoForm.participante,
                                  "inicioEstudios",
                                  $$v
                                )
                              },
                              expression:
                                "alumnoForm.participante.inicioEstudios",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            {
                              attrs: {
                                state:
                                  !_vm.$v.alumnoForm.participante.inicioEstudios
                                    .$invalid,
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.matriculaGpln.form.calculadoInicioGeneracion"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.matriculaGpln.form.finEstudios"
                              ) + " *",
                            "label-for": "input-fin-estudios",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              name: "input-fin-estudios",
                              state:
                                !_vm.$v.alumnoForm.participante.finEstudios
                                  .$invalid,
                              placeholder: _vm.$t(
                                "apeironGwApp.matriculaGpln.form.finEstudios"
                              ),
                              disabled: "",
                            },
                            model: {
                              value: _vm.alumnoForm.participante.finEstudios,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.alumnoForm.participante,
                                  "finEstudios",
                                  $$v
                                )
                              },
                              expression: "alumnoForm.participante.finEstudios",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-form-invalid-feedback",
                            {
                              attrs: {
                                state:
                                  !_vm.$v.alumnoForm.participante.finEstudios
                                    .$invalid,
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.matriculaGpln.form.calculadoDuracionMeses"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label:
                              _vm.$t(
                                "apeironGwApp.matriculaGpln.form.institucion"
                              ) + " *",
                            "label-for": "input-institucion",
                          },
                        },
                        [
                          _c("b-form-select", {
                            staticClass: "resaltar-opciones-disabled",
                            attrs: {
                              name: "input-institucion",
                              options: _vm.instituciones,
                              placeholder: _vm.$t(
                                "apeironGwApp.matriculaGpln.form.institucion"
                              ),
                              state:
                                !_vm.$v.alumnoForm.participante.institucion
                                  .$invalid,
                              disabled:
                                _vm.instituciones.length < 2 || _vm.readOnly,
                              title:
                                _vm.alumnoForm.participante.institucion
                                  ?.nombreInstitucion,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.seleccionarInstitucion()
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "first",
                                fn: function () {
                                  return [
                                    _c(
                                      "b-form-select-option",
                                      {
                                        attrs: {
                                          value: undefined,
                                          disabled: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.matriculaGpln.form.seleccionarUno"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.alumnoForm.participante.institucion,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.alumnoForm.participante,
                                  "institucion",
                                  $$v
                                )
                              },
                              expression: "alumnoForm.participante.institucion",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            label:
                              _vm.$t("apeironGwApp.matriculaGpln.form.sede") +
                              " *",
                            "label-for": "input-sede",
                          },
                        },
                        [
                          _c("b-form-select", {
                            staticClass: "resaltar-opciones-disabled",
                            attrs: {
                              name: "input-sede",
                              options: _vm.sedes,
                              placeholder: _vm.$t(
                                "apeironGwApp.matriculaGpln.form.sede"
                              ),
                              state:
                                !_vm.$v.alumnoForm.participante.sede.$invalid,
                              disabled: _vm.sedes.length < 2 || _vm.readOnly,
                              title: `${_vm.alumnoForm.participante.sede?.nombreDependencia} (${_vm.alumnoForm.participante.sede?.sede})`,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "first",
                                fn: function () {
                                  return [
                                    _c(
                                      "b-form-select-option",
                                      {
                                        attrs: {
                                          value: undefined,
                                          disabled: "",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.matriculaGpln.form.seleccionarUno"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.alumnoForm.participante.sede,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.alumnoForm.participante,
                                  "sede",
                                  $$v
                                )
                              },
                              expression: "alumnoForm.participante.sede",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            "label-size": "md",
                            label: _vm.$t(
                              "apeironGwApp.persona.participacion.becario.comprobanteNacionalidad"
                            ),
                            "label-for": "input-comprobante-nacionalidad",
                          },
                        },
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              attrs: {
                                state:
                                  !_vm.$v.alumnoForm.participante
                                    .comprobanteNacionalidad.$invalid,
                                size: "md",
                                disabled: _vm.readOnly,
                                name: "input-comprobante-nacionalidad",
                              },
                              model: {
                                value:
                                  _vm.alumnoForm.participante
                                    .comprobanteNacionalidad,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.alumnoForm.participante,
                                    "comprobanteNacionalidad",
                                    $$v
                                  )
                                },
                                expression:
                                  "alumnoForm.participante.comprobanteNacionalidad",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.persona.participacion.becario.comprobanteNacionalidadDescripcion"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-row", [_c("b-col", [_c("hr")])], 1),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "text-right pb-2" },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    type: "button",
                    variant: "primary",
                    disabled: _vm.formularioIsInvalid || _vm.readOnly,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.guardarAlumno()
                    },
                  },
                },
                [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("apeironGwApp.matriculaGpln.acciones.guardar")
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("font-awesome-icon", {
                    staticClass: "mr-2",
                    attrs: { icon: "save" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { type: "button", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.limpiarDatos()
                    },
                  },
                },
                [
                  _c("span", {
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("apeironGwApp.matriculaGpln.acciones.reset")
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("font-awesome-icon", {
                    staticClass: "mr-2",
                    attrs: { icon: "refresh" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }